'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ function AuthorizationDirective() {
    return {
        restrict: 'EA',
        transclude: true,
        scope: {
            pages: '=',
            currentPage: '=',
            admin: '='
        },
        template: [
            "<span ng-transclude ng-if='showItem'> </span>"
        ].join(''),
        link: function (scope, element, attrs, ngModel) {
            "use strict";
            scope.showItem = false;
            scope.$watch(function () {
                return scope.pages != undefined && scope.currentPage != undefined && scope.admin
            }, function () {
                if (util.isDefined(scope.pages) && util.isDefined(scope.currentPage) && util.isDefined(scope.admin)) {
                    if (scope.admin) {
                        scope.showItem = true;
                    } else {
                        var found = arrayUtil.getFirstInList(scope.pages, 'name', scope.currentPage);
                        scope.showItem = util.isDefined(found);
                    }
                }
            })
        }
    }
};